export const OPTION_CHANGE = 'OPTION_CHANGE';
export const NEW_OPTION_CREATE = 'NEW_OPTION_CREATE';
export const NEW_OPTION_CREATE_SUCCESS = 'NEW_OPTION_CREATE_SUCCESS';
export const NEW_OPTION_CREATE_FAILURE = 'NEW_OPTION_CREATE_FAILURE';
export const OPEN_FORM_MODAL = 'OPEN_FORM_MODAL';
export const CLOSE_FORM_MODAL = 'CLOSE_FORM_MODAL';


// WEBPACK FOOTER //
// ./src/types/selectActionTypes.js